import React from "react";
import { HostGameData } from "./types";

/// @ts-ignore We'll have the data whenever it's used
export const HostGameContext = React.createContext<HostGameData>({});
